(function () {
  function initGallery(mediaList) {
    if (mediaList.dataset.fadeInitialized) return;

    var slides = Array.prototype.slice.call(mediaList.querySelectorAll('.product__media-item'));
    if (slides.length < 2) return;

    mediaList.dataset.fadeInitialized = 'true';

    var wrapper = mediaList.closest('media-gallery');
    if (!wrapper) return;

    // Respect whichever slide Dawn already marked as the active one
    // (tied to the selected variant's featured media) instead of
    // assuming it's always the first — that mismatch is what caused
    // the wrong photo to show initially.
    var activeIndex = slides.findIndex(function (slide) {
      return slide.classList.contains('is-active');
    });
    if (activeIndex === -1) activeIndex = 0;

    // Inline styles (not classes) so nothing in Dawn's own stylesheet
    // can out-specificity or reorder these rules — that ambiguity is
    // the likely cause of the stacked zoom buttons and wrong-photo
    // bug last time.
    mediaList.style.position = 'relative';
    mediaList.style.overflow = 'hidden';

    slides.forEach(function (slide, index) {
      slide.style.position = 'absolute';
      slide.style.top = '0';
      slide.style.left = '0';
      slide.style.width = '100%';
      slide.style.height = '100%';
      slide.style.transition = 'opacity 0.25s ease';

      var isActive = index === activeIndex;
      slide.style.opacity = isActive ? '1' : '0';
      slide.style.pointerEvents = isActive ? 'auto' : 'none';
      slide.style.zIndex = isActive ? '1' : '0';
    });

    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'mobile-gallery-dots';

    slides.forEach(function (slide, index) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'mobile-gallery-dots__dot';
      dot.setAttribute('aria-label', 'Go to image ' + (index + 1));
      if (index === activeIndex) dot.classList.add('is-active');
      dot.addEventListener('click', function () {
        goTo(index);
      });
      dotsWrap.appendChild(dot);
    });

    wrapper.appendChild(dotsWrap);
    var dots = dotsWrap.querySelectorAll('.mobile-gallery-dots__dot');

    function goTo(index) {
      if (index < 0 || index >= slides.length || index === activeIndex) return;

      slides[activeIndex].style.opacity = '0';
      slides[activeIndex].style.pointerEvents = 'none';
      slides[activeIndex].style.zIndex = '0';
      dots[activeIndex].classList.remove('is-active');

      slides[index].style.opacity = '1';
      slides[index].style.pointerEvents = 'auto';
      slides[index].style.zIndex = '1';
      dots[index].classList.add('is-active');

      activeIndex = index;
    }

    var startX = 0;
    var startY = 0;
    var tracking = false;

    mediaList.addEventListener(
      'touchstart',
      function (event) {
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        tracking = true;
      },
      { passive: true }
    );

    mediaList.addEventListener(
      'touchend',
      function (event) {
        if (!tracking) return;
        tracking = false;

        var deltaX = event.changedTouches[0].clientX - startX;
        var deltaY = event.changedTouches[0].clientY - startY;

        if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;

        if (deltaX < 0) {
          goTo(activeIndex + 1);
        } else {
          goTo(activeIndex - 1);
        }
      },
      { passive: true }
    );
  }

  function init() {
    if (window.matchMedia('(min-width: 750px)').matches) return;
    document.querySelectorAll('product-info .product__media-list').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
